
class ActionResourceObject {
    constructor() {
        this.status = "NO_ACTION"
        this.value = null
        this.error = null

        this.status = {
            REQUEST: "REQUEST",
            REQUEST_SUCCESS: "REQUEST_SUCCESS",
            REQUEST_FAIL: "REQUEST_FAILURE",
            NO_ACTION: "NO_ACTION",
        }
    }

    setStatus(status) {
        this.status = status
    }

    setValue(value) {
        this.value = value
    }
    getData() {
        return this.value
    }

}

export default ActionResourceObject


// WEBPACK FOOTER //
// ./src/app/core/ActionResourceObject.js